import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import title from 'assets/images/toa-title.svg';
import { ModalWrapper } from 'components/Modals';
import './JoinCreateTeamModal.scss';
import { JoinCreateTeamTour } from 'components/Tours';
import { useSelector } from 'react-redux';
import { RootStore } from 'redux/store';

interface OnboardingProps {
	open: boolean;
	hideBackdrop: boolean;
	allowClickOutsideToClose?: boolean;
	onJoinTeamClicked: () => void;
	onCreateTeamClicked: () => void;
	onSendShoutOutClicked: () => void;
	onCloseClicked?: () => void;
}



const JoinCreateTeam: React.FC<OnboardingProps> = (props: OnboardingProps) => {
	const { open, hideBackdrop, allowClickOutsideToClose, onJoinTeamClicked, onCreateTeamClicked, onSendShoutOutClicked, onCloseClicked } = props;
	const [additionalClass, setAdditionalClass] = useState('');
	const [isTourOpen, setIsTourOpen] = useState(false);
	const userState = useSelector((state: RootStore) => state.user);
	const [isLaunchScreen, setIsLaunchScreen] = useState(false);

	useEffect(() => {
		// check for IE 11
		if (navigator.appVersion.indexOf('Trident/') > -1) {
			setAdditionalClass('space-around');
		}

		const url = window.location.href;
		if (!url.includes('/team/')) {
			setIsLaunchScreen(true);
		} else {
			setIsLaunchScreen(false);
		}
	}, []);

		// Use effect for managing if the tour should show or not
	useEffect(() => {
		if (open && !userState.tours.includes('JoinCreateTeamModalTour')) {
			setTimeout(function () {
				setIsTourOpen(true);
			}, 500);
		}
	}, [userState.tours, open]);

	return (
		<>
		<ModalWrapper open={open} hideBackdrop={hideBackdrop} onCloseClicked={onCloseClicked} allowClickOutsideToClose={allowClickOutsideToClose}>
			<div className='join-create-paper'>
				<div className='join-create__title-wrapper'>
					<img className='join-create__title' src={title} alt='tokens of appreciation'></img>
				</div>

				<div className={`join-create__button-wrapper ${additionalClass}`}>
					{isLaunchScreen ? (
						<div className='team-buttons'>
							<Button id='join-create__existing-team-button' variant='contained' color='primary' onClick={onJoinTeamClicked}>
								Join an existing team
							</Button>

							<Button id='join-create__new-team-button' variant='contained' color='primary' onClick={onCreateTeamClicked}>
								Create a new team
							</Button>
						</div>
					) : (
						<Button id='join-create__existing-team-button' variant='contained' color='primary' onClick={onJoinTeamClicked}>
							Join an existing team
						</Button>
					)}

					<div className='button-divider'>
						<hr />
						<div className='divider-text'>or</div>
						<hr />
					</div>

					{isLaunchScreen ? (
						<Button className='shout-out-button glow--simple' variant='contained' onClick={onSendShoutOutClicked}>
							Send Shout-Out
						</Button>
					) : (
						<Button id='join-create__new-team-button' variant='contained' color='primary' onClick={onCreateTeamClicked}>
							Create a new team
						</Button>
					)}
				</div>
				</div>
			</ModalWrapper>
			<JoinCreateTeamTour open={isTourOpen} onClose={() => setIsTourOpen(false)} />
		</>
	);
};

export default JoinCreateTeam;
